module.exports = __webpack_public_path__ + "img/social-grid-node.d2cc3e6.jpg";